import { Card, Col, Row } from 'antd';
import React from 'react';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";


import AddTermination from './AddTermination';
import GetAllTerminationData from './terminatinData';

const TerminationForm = (props) => {
    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }
    return (

        <>
            <PageTitle title='Back' />
            <Row gutter={16}>
                <Col span={8}>
                    <Card title="Employee Termination">
                        <AddTermination />
                    </Card>
                </Col>
                <Col span={16}>
                    <Card title="Employee Termination Log">
                        <GetAllTerminationData />
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default TerminationForm;
